import {
  SET_CUSTOMER_REPORTS_LOADING,
  GET_CUSTOMER_REPORTS_SUCCESS,
  GET_CUSTOMER_REPORTS_ERROR,
} from '../actions/types';

const initialState = {
  isLoading: false,
  customerReports: [],
  pagination: {},
  error: null,
};

const customerReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_REPORTS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case GET_CUSTOMER_REPORTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customerReports: action.payload.data,
        pagination: action.payload.pagination,
        error: null,
      };
    case GET_CUSTOMER_REPORTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default customerReportsReducer;
